<template>
    <div class="type-div">
        <!-- <div v-if="backgroundUrl" :style="{ backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : ''}"> -->
        <!-- <div v-if="backgroundUrl" class="img-box" :style="{ backgroundImage: `url(${backgroundUrl})`}">
        </div> -->
        <img v-if="backgroundUrl" class="img-box" :src="backgroundUrl" alt=""/>
        <img v-else class="img-box" src="./smileLibrarySelection.svg" alt=""/>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import Rectangular from './Rectangular.svg';
import Squared from './Squared.svg';
import Triangular from './Triangular.svg';

const props = defineProps({
    paramsBg: {
        type: String,
        required: true
    }
})
const imageUrlList = [ 'Rectangular', 'Squared', 'Triangular' ];
// const backgroundUrl = ref(require('./smileLibrarySelection.svg'));
const backgroundUrl = ref('');
// const backgroundUrl = computed(() => imageUrlList.includes(props.paramsBg) ? require(`./${props.paramsBg}.svg`) : require('./smileLibrarySelection.svg'));

const imageFileList = {
    Triangular,
    Squared,
    Rectangular
};

watch(() => props.paramsBg, (newValue, oldValue)=> {
    // 微笑形态已有值，点击其他地方传paramsBg为''时，背景图为选中值的图
    if( !(!newValue && oldValue) ){
        // paramsBg为微笑形态下的选项时，背景图变为对应选项的图；否则图不变
        if( imageUrlList.includes(props.paramsBg) ){
            backgroundUrl.value = imageFileList[props.paramsBg];
        }
    } else {
        if( imageUrlList.includes(oldValue) ){
            backgroundUrl.value = imageFileList[oldValue];
        }
    }
}, {immediate: true})
</script>

<style lang="scss" scoped>
.type-div{
    .img-box{
        width: 100%;
        height: 100%;
        background-size: 100% 100% !important;
        background-repeat: no-repeat;
    }
}
</style>